import { ref, Ref } from 'vue';
import { LinkModel } from '@/types/B2CcontentServerContract';

const requestSpecialDelivery: Ref<LinkModel | null> = ref(null);

export default function useSpecialDeliveryRequest() {
    const setLink = (value: LinkModel) => {
        requestSpecialDelivery.value = value;
    };

    return {
        setLink,
        requestSpecialDelivery,
    };
}
